/**
 * Redakcja `queryKey` przed wyslaniem gdziekolwiek poza aplikacje.
 *
 * `QueryCache.onError` serializuje caly klucz do taga Sentry i do
 * `console.error`. Jesli ktokolwiek wstawi do klucza sekret (a tak bylo
 * z tokenem sesji publicznej KSeF — F20 skanu 2026-08-08), kazdy blad zapytania
 * wysyla go do zewnetrznego serwisu. Klucze maja byc budowane z nietajnych
 * dyskryminatorow, ale to jest druga warstwa: nawet gdy ktos sie pomyli,
 * wartosc wygladajaca na sekret nie wyjdzie na zewnatrz.
 */

/** Zamiennik wstawiany w miejsce wartosci wygladajacej na sekret. */
export const REDACTED = "[redacted]";

/**
 * Czy string wyglada na sekret (token/klucz/hash), a nie na zwykly parametr
 * zapytania. Celowo konserwatywnie: dlugi ciag bez spacji zlozony ze znakow
 * typowych dla tokenow. Zwykle wartosci kluczy (nazwy zasobow, daty, NIP-y,
 * scope) sa krotsze albo zawieraja znaki spoza tego zbioru.
 */
export function looksLikeSecret(value: string): boolean {
	if (value.length < 24) return false;
	if (/\s/.test(value)) return false;
	// Prefiksy poswiadczen uzywane w tym systemie.
	if (/^(fd_|fm_|fe_|eyJ)/.test(value)) return true;
	// Base64/hex-podobny ciag bez separatorow slownych.
	return /^[A-Za-z0-9+/=_-]{24,}$/.test(value);
}

/**
 * Rekurencyjnie zastepuje wartosci wygladajace na sekret. Ksztalt klucza
 * zostaje nienaruszony, zeby grupowanie bledow w Sentry dalej dzialalo.
 */
export function redactQueryKey(key: unknown): unknown {
	if (typeof key === "string") {
		return looksLikeSecret(key) ? REDACTED : key;
	}
	if (Array.isArray(key)) {
		return key.map(redactQueryKey);
	}
	if (key && typeof key === "object") {
		return Object.fromEntries(
			Object.entries(key as Record<string, unknown>).map(([k, v]) => [k, redactQueryKey(v)]),
		);
	}
	return key;
}
